export default {
    moves: 'Træk',
    time: 'Tid',
    score: 'Score',
    settings: 'Indstillinger',
    sounds: 'Lyd',
    autocomplete: 'Autoudfyld',
    leftHanded: 'Venstrehåndet',
    newDeal: 'Ny kortuddeling',
    design: 'Design',
    easy: 'Nemt',
    medium: 'Medium',
    hard: 'Svært',
    expert: 'Ekspert',
    master: 'Master',
    random: 'Tilfældig',
    rulesKlondikeURL: 'https://solitaires.com/dk/articles/how-to-play-solitaire/',
    cardHighlight: 'Fremhævelse af kortet',
    rulesSpiderURL: 'https://solitaires.com/dk/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/dk/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'Autoplay',
    noMagicNeeded: 'Ingen tryllestav nødvendig — fortsæt selv spillet!',
    leaveFeedback: 'Efterlad din feedback',
    feedbackThankYou: 'Vi sætter pris på din feedback!',
    feedbackError: 'Der opstod en fejl. Din besked blev ikke sendt.',
    thanksSubscribing: 'Tak fordi du abonnerede!',
};
